import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Auth/Login";
import Register from "./Pages/Auth/Register";
import AllCategoryPage from "./Pages/Category/AllCategoryPage";
import AllBrand from "./Pages/Brand/AllBrand";
import ShopProducts from "./Pages/Products/ShopProducts";
import ProductDetails from "./Pages/Products/ProductDetails";
import CartPage from "./Pages/Cart/CartPage";
import PaymentMethod from "./Pages/CheckOut/PaymentMethod";
import AdminAllProducts from "./Pages/Admin/AdminAllProducts";
import AdminAllOrders from "./Pages/Admin/AdminAllOrders";
import AdminOrderDetails from "./Pages/Admin/AdminOrderDetails";
import AdminAddBrand from "./Pages/Admin/AdminAddBrand";
import AdminAllBrands from "./Pages/Admin/AdminAllBrands";
import AdminAddCategory from "./Pages/Admin/AdminAddCategory";
// import AdminAddSubCategory from "./Pages/Admin/AdminAddSubCategory";
import AdminAddProduct from "./Pages/Admin/AdminAddProduct";
import UserAllOrders from "./Pages/User/UserAllOrders";
import UserFavoriteProducts from "./Pages/User/UserFavoriteProducts";
import UserAllAddresses from "./Pages/User/UserAllAddresses";
import UserProfile from "./Pages/User/UserProfile";
import AdminEditProduct from "./Pages/Admin/AdminEditProduct";
import ForgetPassword from "./Pages/Auth/ForgetPassword";
import VerfiyPassword from "./Pages/Auth/VerfiyPassword";
import ResetPassword from "./Pages/Auth/ResetPassword";
import AdminAddCoupon from "./Pages/Admin/AdminAddCoupon";
import UserAddAddress from "./Pages/User/UserAddAddress";
import UseProtectedLinks from "./CustomHooks/Auth/UseProtectedLinks";
import ProtectedRoute from "./components/Layout/ProtectedRoute";
import ProductByCategory from "./Pages/Products/ProductByCategory";
import AdminEditBrand from "./Pages/Admin/AdminEditBrand";
import AdminAllCategory from "./Pages/Admin/AdminAllCategory";
// import AdminAllSubCategory from "./Pages/Admin/AdminAllSubCategory";
import AdminAllCoupons from "./Pages/Admin/AdminAllCoupons";
import AdminEditCategory from "./Pages/Admin/AdminEditCategory";

function App() {
  const [isLogin, isUser, isAdmin] = UseProtectedLinks()
  return (
    <div className="App d-flex flex-column mh-100vh ">
      <section className="content">
        <BrowserRouter>
          <Routes>
            <Route index element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/allcategory" element={<AllCategoryPage />} />
            <Route path="/allbrand" element={<AllBrand />} />
            <Route path="/shopproduct" element={<ShopProducts />} />
            <Route path="/product/:id" element={<ProductDetails />} />
            <Route path="/product/category/:catid" element={<ProductByCategory />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/user/forgetpassword" element={<ForgetPassword />} />
            <Route path="/user/VerfiyCode" element={<VerfiyPassword />} />
            <Route path="/user/resetpassword" element={<ResetPassword />} />

            <Route element={<ProtectedRoute auth={isAdmin} />} >
              <Route path="/admin/allproducts" element={<AdminAllProducts />} />
              <Route path="/admin/allorders" element={<AdminAllOrders />} />
              <Route path="/admin/orders/:id" element={<AdminOrderDetails />} />
              <Route path="/admin/addbrand" element={<AdminAddBrand />} />
              <Route path="/admin/addcoupon" element={<AdminAddCoupon />} />
              <Route path="/admin/addcategory" element={<AdminAddCategory />} />
              {/* <Route path="/admin/addsubcategory" element={<AdminAddSubCategory />} /> */}
              <Route path="/admin/addproduct" element={<AdminAddProduct />} />
              <Route path="/admin/editproduct/:id" element={<AdminEditProduct />} />
              <Route path="/admin/allbrands" element={<AdminAllBrands />} />
              <Route path="/admin/editbrand/:id" element={<AdminEditBrand />} />
              <Route path="/admin/editcategory/:id" element={<AdminEditCategory />} />
              <Route path="/admin/allcategory" element={<AdminAllCategory />} />
              {/* <Route path="/admin/allsubcategory" element={<AdminAllSubCategory />} /> */}
              <Route path="/admin/allcoupons" element={<AdminAllCoupons />} />
            </Route>

            <Route element={<ProtectedRoute auth={isUser} />}>
              <Route path="/user/allorders" element={<UserAllOrders />} />
              <Route path="/user/favoriteproducts" element={<UserFavoriteProducts />} />
              <Route path="/user/alladdresses" element={<UserAllAddresses />} />
              <Route path="/user/add-address" element={<UserAddAddress />} />
              <Route path="/user/profile" element={<UserProfile />} />
              <Route path="/paymentmethod" element={<PaymentMethod />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </section>
    </div>
  );
}

export default App;
